import { useRouter } from 'found';
import PropTypes from 'prop-types';
import React from 'react';
import EventCard from 'containers/cards/Event';

const EventList = ({
  eventConnection,
  viewer,
  handleLike,
  data,
  setEventData,
}) => {
  const { router } = useRouter();
  return eventConnection?.map(event => {
    return (
      <EventCard
        setEventData={setEventData}
        data={data}
        event={event}
        compact
        key={event.id}
        onClickDiv={() => router.push(`/events/${encodeURIComponent(event.slug)}`)}
        viewer={viewer}
        handleLike={handleLike}
      />
    );
  });
};

EventList.propTypes = {
  eventConnection: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
  handleLike: PropTypes.func.isRequired,
};

export default EventList;
